import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { GoEye, GoEyeClosed } from "react-icons/go";
import ar from '../../language/Ar';
import en from '../../language/En';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
function Forget() {
      const { lang } = useSelector((state) => state.language);
      const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    reset,
    setValue
  } = useForm({
    mode: "onBlur",
  });
  const [yes, setYes] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [timer, setTimer] = useState(90); // 1.5 minutes = 90 seconds
  const [canResend, setCanResend] = useState(false); 
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const getOtp = async () => {
    // const isValid = await trigger("username"); // Validate email field
    // if (!isValid) {
    //   return; 
    // }
    // setLoading(true);
    // try {
    //   const res = await postApi(API_PATH.AUTH.GENRATE_OTP, {
    //     email: email,
    //   });
    //   if (res.data.status) {
    //     setYes(true);
    //     setTimer(90);
    //     setCanResend(false);
    //     setLoading(false);
    //     toast.success("Otp Sent Successfully");
    //   }else{
    //     toast.error(res.data.message ||"Email doesn't exists")
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.log("error", error);
    //   setLoading(false);
    // }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const handleResend = async () => {
    setShowPassword(false);
    setShowConfirmPassword(false);
    reset({
      otp: "",
      password: "",
      confirmPassword: ""
    });
    setValue("username", email); // Set the email value explicitly
    getOtp();
  };
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-gray-800 rounded-xl p-6 shadow-lg">
        <div className="text-center">
            <img
              src="/images/logo/logo.jpeg"
              className="w-[80px] h-[80px] rounded-full mx-auto my-2"
              alt="logo"
            />
            <h2 className="text-white text-3xl font-bold mb-2">jeema</h2>
            <p className="text-gray-400 text-lg">Forget Password</p>
          </div>
          <form
  key={1}
  // onSubmit={handleSubmit(onSubmit)}
  className={yes ? 'w-full max-w-md  dark:bg-gray-800 p-8 ' : 'w-full max-w-md  dark:bg-gray-800 p-8 '}
  autoComplete="off"
>
 

  {/* Email */}
  <input
    type="email"
    name="email"
    placeholder="Email"
    {...register("username", {
      required: "Email is required.",
      pattern: {
        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
        message: "Email is not valid.",
      },
      onChange: (e) => setEmail(e.target.value),
    })}
    value={email}
    disabled={yes}
    className="w-full mb-3 px-4 py-2 bg-gray-600 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A] disabled:opacity-50"
  />
  {errors.username && (
    <span className="text-red-500 text-sm">{errors.username.message}</span>
  )}

  {/* Conditional Section */}
  {yes && (
    <>
     
      <input
        type="text"
        name="otp"
        maxLength={6}
        placeholder="OTP"
        {...register("otp", {
          required: "OTP is required.",
          validate: (value) =>
            value.length >= 6 || "OTP should be of 6 characters.",
        })}
        onChange={(e) => setOtp(e.target.value)}
        className="w-full mb-3 px-4 py-2  bg-gray-600 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A]"
      />
      {errors.otp && (
        <span className="text-red-500 text-sm">{errors.otp.message}</span>
      )}

     
      <div className="relative mb-3">
        <input
          type={showPassword ? "text" : "password"}
          name="pswd"
          placeholder="New Password"
          {...register("password", {
            validate: {
              checkLength: (value) => value.length >= 9,
              matchPattern: (value) =>
                /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)(?=.*[!@#$*])/.test(
                  value
                ),
            },
          })}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-2 bg-gray-600 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A]"
        />
        <span className="absolute top-2 right-3 text-xl cursor-pointer">
          {showPassword ? (
            <GoEye onClick={toggleShowPassword} />
          ) : (
            <GoEyeClosed onClick={toggleShowPassword} />
          )}
        </span>
      </div>

      {/* Password errors */}
      {errors.password?.type === "checkLength" && (
        <span className="text-red-500 text-sm">
          Password should be at least 9 characters.
        </span>
      )}
      {errors.password?.type === "matchPattern" && (
        <span className="text-red-500 text-sm">
          Must contain uppercase, lowercase, digit, special symbol.
        </span>
      )}

      
      <div className="relative mb-3">
        <input
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Confirm Password"
          autoComplete="new-password"
          {...register("confirmPassword", {
            validate: (value) =>
              value === watch("password") || "Passwords do not match",
          })}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full px-4 py-2 bg-gray-600 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#5A189A]"
        />
        <span className="absolute top-2 right-3 text-xl cursor-pointer">
          {showConfirmPassword ? (
            <GoEye onClick={toggleShowConfirmPassword} />
          ) : (
            <GoEyeClosed onClick={toggleShowConfirmPassword} />
          )}
        </span>
      </div>
      {errors.confirmPassword && (
        <span className="text-red-500 text-sm">{errors.confirmPassword.message}</span>
      )}

      
      <div className="text-center mt-4">
        <button
          type="submit"
          className="bg-[#5A189A] hover:bg-[#3C096C] text-white px-6 py-2 rounded"
        >
          Change Password
        </button>
      </div>

      
      {canResend ? (
        <div className="text-center mt-2">
          <button
            type="button"
            onClick={handleResend}
            className="text-sm text-blue-600 hover:underline"
          >
            Resend Code
          </button>
        </div>
      ) : (
        <p className="text-sm text-center text-gray-500 mt-2">
          Resend code in{" "}
          <span className="text-red-600">
            {Math.floor(timer / 60)}:{String(timer % 60).padStart(2, "0")}
          </span>
        </p>
      )}
    </>
  )}

  {/* Get OTP Section */}
  {!yes && (
    <>
      <div className="text-center mt-4">
        <button
          className="bg-[#5A189A] hover:bg-[#3C096C] text-white px-6 py-2 rounded"
          onClick={() => getOtp()}
        >
          Get OTP
        </button>
      </div>
      <div className="text-sm text-center mt-2 text-gray-500 dark:text-gray-300">
        Remember Password?{" "}
        <Link to="/login" className="text-blue-600 hover:underline ml-1">
          Login
        </Link>
      </div>
    </>
  )}
</form>

        </div>
    </div>
  )
}

export default Forget